<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="fornecedores.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="fornecedores.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum fornecedor encontrado"
      loading-text="Carregando fornecedores..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        {{ item.codigoInterno | naoInformado}}
      </template>
      <template v-slot:item.nome="{ item }">
        {{ item.fornecedor.pessoa.nome }}
        <px-open-pagina-fornecedor :id="item.fornecedor.id" :is-icon="false"/>
      </template>
      <template v-slot:item.cnpj="{ item }">
        {{ item.fornecedor.pessoa.cnpj | cnpj }}
      </template>
      <template v-slot:item.situcacao="{ item }">
        <px-ativo :ativo="!item.fornecedor.disabled"/>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="`fornecedor/${item.id}`">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <v-btn icon @click="onClickRemove(item)" v-if="hasModuleGerencia">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GestaoFornecedorService from './gestao-fornecedor-service';

export default {
  props: {
    fornecedores: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código interno',
          value: 'codigoInterno',
        },
        {
          text: 'Nome',
          value: 'nome',
        },
        {
          text: 'CNPJ',
          value: 'cnpj',
        },
        {
          text: 'Situação',
          value: 'situcacao',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
  },
  methods: {
    remove(item) {
      GestaoFornecedorService.remove(item.id)
        .then(() => {
          this.$toast('Fornecedor removido', { color: 'success' });
          this.emitUpdate();
        });
    },
    onClickRemove(item) {
      this.$refs.confirm.open('Você deseja remover este fornecedor?',
        'O fornecedor será removido e esta operação não pode ser desfeita.',
        { width: 330 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
